<markant-platform-ui-card class="management-tile">
  <h4 class="header">
    {{
      'dashboard.cartridge.bookingAndContractTileHeaders.booking' | transloco
    }}
  </h4>
  @if (managementData.bookingDate) {
    <section class="information-item">
      <h6 class="information-item-subheader">
        {{ 'dashboard.cartridge.overviewTable.col.bookingDate' | transloco }}
      </h6>
      <p class="information-item-value">
        {{ managementData.bookingDate | translocoDate }}
      </p>
    </section>
  }

  @if (!!managementData.workflowFinishedAt) {
    <section class="information-item">
      <h6 class="information-item-subheader">
        {{
          'dashboard.cartridge.overviewTable.col.' +
            (managementData.usageRightActivationState === 'DECLINED'
              ? 'bookingDeclinedAt'
              : 'bookingConfirmedAt') | transloco
        }}
      </h6>
      <p class="information-item-value">
        {{ managementData.workflowFinishedAt | translocoDate }}
      </p>
    </section>
  }

  @if (managementData.bookingStartedAt) {
    <section class="information-item">
      <h6 class="information-item-subheader">
        {{
          'dashboard.cartridge.overviewTable.col.bookingStartedAt' | transloco
        }}
      </h6>
      <p class="information-item-value">
        {{ managementData.bookingStartedAt | translocoDate }}
      </p>
    </section>

    @if (
      managementData.usageRightActivationState === 'UPGRADED' &&
      managementData.serviceUpgradeRequestData?.upgradeCompletedAt
    ) {
      <section class="information-item">
        <h6 class="information-item-subheader">
          {{
            'dashboard.cartridge.overviewTable.col.validityPeriodEnd'
              | transloco
          }}
        </h6>
        <p class="information-item-value">
          {{
            managementData.serviceUpgradeRequestData!.upgradeCompletedAt
              | translocoDate
          }}
        </p>
      </section>
    }
  }

  <!-- If it has the new contractStartDate property, use it as the contract start date -->
  @if (managementData.contractStartDate) {
    <h4 class="header">
      {{
        'dashboard.cartridge.bookingAndContractTileHeaders.contract' | transloco
      }}
    </h4>
    <section class="information-item">
      <h6 class="information-item-subheader">
        {{
          'dashboard.cartridge.overviewTable.col.contractStartAt' | transloco
        }}
      </h6>
      <p class="information-item-value">
        {{ managementData.contractStartDate | translocoDate }}
      </p>
    </section>
    <!-- If not and the variant is accepted, show workflowFinishedAt instead -->
  } @else if (
    !!managementData.workflowFinishedAt &&
    managementData.usageRightActivationState !== 'DECLINED'
  ) {
    <h4 class="header">
      {{
        'dashboard.cartridge.bookingAndContractTileHeaders.contract' | transloco
      }}
    </h4>
    <section class="information-item">
      <h6 class="information-item-subheader">
        {{
          'dashboard.cartridge.overviewTable.col.contractStartAt' | transloco
        }}
      </h6>
      <p class="information-item-value">
        {{ managementData.workflowFinishedAt | translocoDate }}
      </p>
    </section>
  }
</markant-platform-ui-card>
